import { AirlineRating, IAirlineDetailDTO } from 'api/swagger/ApiClient';
import { autoinject, BindingEngine, customElement } from 'aurelia-framework';
import { Router } from 'aurelia-router';
import { bindable } from 'aurelia-typed-observable-plugin';
import { ValidationRules } from 'aurelia-validation';
import { watch } from 'aurelia-watch-decorator';
import { AirlineStatus } from 'model/business-enums';
import { EnumsService } from 'services/enums-service';
import { ModelBase } from 'support/base_classes/model-base';

@autoinject
@customElement('airline-form')
export class AirlineFormCustomElement extends ModelBase<IAirlineDetailDTO> {
  @bindable autofocus = false;
  @bindable disabled = false;

  constructor(private router: Router, bindingEngine: BindingEngine, private enumService: EnumsService) {
    super(bindingEngine);
  }

  modelChanged(newValue: IAirlineDetailDTO) {
    super.modelChanged(newValue);
    ValidationRules
      .ensureObject<IAirlineDetailDTO>().required()
      .ensure(model => model.name).displayName('Airline Name').required()
      .ensure(model => model.code).displayName('Airline Code').required()
      .ensure(model => model.airlineRating).displayName('Rating').required()
      .on(this.model);
  }

  enumsItemMatcher = this.enumService.itemsMatch;

  @watch((x: AirlineFormCustomElement) => x.model.airlineRating)
  updateAirlineStatus() {
    this.model.airlineStatus.name = this.model.airlineRating != null ? (this.model.airlineRating.value === AirlineRating.Class1 || this.model.airlineRating.value === AirlineRating.Class2 ? this.enumService.airlineStatuses.find(x => x.value === AirlineStatus.Approved).name : (this.model?.hasDeviation == true ? this.enumService.airlineStatuses.find(x => x.value === AirlineStatus.ApprovedDeviation).name : this.enumService.airlineStatuses.find(x => x.value === AirlineStatus.NonApproved).name)) : null;
  }
}
